import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
import { ErrorBoundary } from './components/ErrorBoundary';
import { IndustryProvider } from './context/IndustryContext';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <IndustryProvider>
        <App />
      </IndustryProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
